import React, {FC, useEffect, useState} from 'react';
import actions from 'store/actions';
import {INonMember} from 'types/nonMember';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {ModalViewEnum} from '.';

interface PreviewProfileProps {
  lead: Partial<INonMember>;
  setView: React.Dispatch<React.SetStateAction<ModalViewEnum>>;
}

export const PreviewProfile: FC<PreviewProfileProps> = ({setView, lead}) => {
  const [previewDataUrl, setPreviewDataUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    async function generateAgreementFile() {
      try {
        const response = await actions.publicEvents.generateAgreementFile(lead);

        if (response.data.buffer) {
          const uint8Array = new Uint8Array(response.data.buffer.data);
          const blob = new Blob([uint8Array.buffer], {type: 'application/pdf'});
          const url = URL.createObjectURL(blob);

          setPreviewDataUrl(url);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('err ', err);
      }
      setIsLoading(false);
    }

    generateAgreementFile();

    return () => {
      if (previewDataUrl) {
        URL.revokeObjectURL(previewDataUrl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && (
        <div className="text-center">
          <FontAwesomeIcon icon={faSpinner} pulse />
        </div>
      )}
      {previewDataUrl && (
        <iframe className="w-100 " style={{height: '80vh'}} src={previewDataUrl} title="Preview">
          Your browser does not support PDFs.
        </iframe>
      )}
      {!isLoading && (
        <div className="d-flex justify-content-end pt-2">
          <button className="btn btn-primary ml-2" type="button" onClick={() => setView(ModalViewEnum.SIGN)}>
            Submit
          </button>
          <button className="btn btn-secondary ml-2" type="button" onClick={() => setView(ModalViewEnum.CREATE)}>
            Back
          </button>
        </div>
      )}
    </>
  );
};
